import { render, staticRenderFns } from "./PosSetup.vue?vue&type=template&id=204fb356&"
import script from "./PosSetup.vue?vue&type=script&lang=js&"
export * from "./PosSetup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports